module.exports = __webpack_public_path__ + "static/media/pr.6949cd9f.svg";